import {GraphqlQueryTable} from "../GraphqlQueryTable.jsx";
import {DeleteButton} from "../common/components/DeleteButton.jsx";
import {ToastContainer} from "react-toastify";
import moment from "moment";


const VM_INSTANCE_LOG_LINK = `https://console.cloud.google.com/compute/instancesDetail/zones/us-central1-a/instances/{vmName}?project={vmProjectName}&tab=monitoring&pageState=(%22observabilityTab%22:(%22mainContent%22:%22logs%22))`

export const INSTANCES_QUERY = `query {
        data:powertabsInstances {
           name
           isRunning
           createdAt
           zone
         }
    }`

export const DELETE_MUTATION = `mutation($name: String!) {
        deletePowertabsInstance(name: $name) {
            name
            isRunning
        }
    }`


const buttons = ([
    {
        Header: "Delete Instance",
        Cell: (props) => (<div>
            <DeleteButton
                deleteMutation={DELETE_MUTATION}
                apiParameters={{name: props.row.original.name}}
                filePrefixName={props.row.original.name}
                initDisabled={!props.row.original.isRunning}
            />
        </div>)
    }
])


export const INSTANCES_COLUMNS = () => [
    ...buttons,
    {
        Header: 'Instance Name',
        Cell: (props) => (
            <a target="_blank"
               href={
                VM_INSTANCE_LOG_LINK
                    .replace("{vmName}", props.row.original.name)
                    .replace("{vmProjectName}", process.env.REACT_APP_POWERTABS_GCP)
            }> {props.row.original.name} </a>
        )

    },
    {
        Header: 'Zone',
        Cell: (props) => (
            <span>{props.row.original.zone}</span>
        )
    },
    {
        Header: 'Created At',
        Cell: (props) => (
            <span>{props.row.original.createdAt}</span>
        )
    },
    {
        Header: 'Duration',
        Cell: (props) => {
            const totalMinutes = Math.floor(moment().diff(moment(props.row.original.createdAt)) / 60000)
            const hh = Math.floor(totalMinutes / 60)
            const mm = totalMinutes % 60
            return <span>{hh}:{String(mm).padStart(2, '0')}</span>
        }
    },
]

export const PowertabsInstances = () => {
    return (
        <div>
            <ToastContainer autoClose={3000}/>
            <GraphqlQueryTable
                pageName="Powertabs Instances"
                generateColumns={INSTANCES_COLUMNS}
                query={INSTANCES_QUERY}
                showHeadersWhenEmpty={true}
            />
        </div>
    )
}

